import { useDispatch } from 'react-redux';
import { useEffect } from 'react';

import { setShowPrompt } from 'state/settings/settings-slice';
import { STORAGE, sessionStorageKeys } from 'config/storage-config';
import { useStateMachineContext } from 'machines/hooks/useStateMachineContext';

export const useNavigateToExternalURL = () => {
  const dispatch = useDispatch();
  const { actor } = useStateMachineContext();

  useEffect(() => {
    dispatch(setShowPrompt(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (url) => {
    window.addEventListener('beforeunload', () => {
      actor.stop();
      STORAGE.removeItem(sessionStorageKeys.PARTNER_PATH);
    });

    window.location.assign(url);
  };
};
